import React, { useEffect, useState } from "react";
import "./DLPdfList.css";

export default function DLPdfList() {

  const user = JSON.parse(localStorage.getItem("user"));
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  // ================== DOWNLOAD FUNCTION ==================
  const downloadPDF = (base64Data, dlno) => {

    if (!base64Data) {
      alert("PDF not available");
      return;
    }

    // Handle both with or without prefix
    let base64 = base64Data;

    if (base64.includes("base64,")) {
      base64 = base64.split("base64,")[1];
    }

    try {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });

      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `DL_${dlno}.pdf`;
      a.click();

      URL.revokeObjectURL(url);
    } 
    catch (err) {
      console.error("PDF ERROR:", err);
      alert("Invalid PDF file");
    }
  };


  // ================== FETCH LIST ==================
  useEffect(() => {

    const fetchList = async () => {
      try {
        const res = await fetch(
          `https://rcfinder.online/api/get_dl_list.php?user_id=${user.id}`
        );

        const data = await res.json();
        console.log(data);

        if (data.list) setList(data.list);

      } catch (err) {
        console.log(err);
        alert("Server Error");
      }

      setLoading(false);
    };

    fetchList();

  }, []);



  return (
    <div className="dl-list-wrapper">

      {loading && (
        <div className="dl-list-loading">
          <div className="loader"></div>
          <p>Fetching your DL history...</p>
        </div>
      )}

      <h2 className="dl-list-title">DL PDF History</h2>

      <div className="dl-list-box">

        {list.length === 0 ? (
          <p className="no-data">No DL records found 😐</p>
        ) : (
          <table className="dl-table">

            <thead>
              <tr>
                <th>#</th>
                <th>DL Number</th>
                <th>DOB</th>
                <th>Date</th>
                <th>Download</th>
              </tr>
            </thead>

            <tbody>
              {list.map((r, i) => (
                <tr key={r.id}>
                  <td>{i + 1}</td>
                  <td>{r.dlno}</td>
                  <td>{r.dob || "—"}</td>
                  <td>{r.created_at}</td>

                  <td>
                    <button
                      className="dl-download-btn"
                      onClick={() => downloadPDF(r.pdf_data, r.dlno)}
                    >
                      Download
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        )}

      </div>
    </div>
  );
}
